import dayjs from "dayjs";

export const initialValues = {
  tipoServicio: "",
  // tipoMoneda: "",
  anio: "",
  mes: "",
  ingresoServicio: "",
  montoPagar: 0,
  montoAporte: 0,
  mora: 0,
  moraAporte: 0,
  descripcion: "",
  fechaEmision: dayjs(),
  fechaVencimiento: "",
  fechaPago: "",
  declaracionISV: null,
  detalleIngreso: null,
};

export const initialValuesDatosPersonales = {
  identidad: "",
  rtn: "",
  telefono: "",
  correo: "",
  direccion: "",
};

export const initialValuesContactos = {
  nombreContacto: "",
  telefonoContacto: "",
  emailContacto: "",
  cargo: "",
  identidadContacto: "",
  direccionContacto: "",
};
